import type { Tap } from "../../sim";

/**
 * Collects taps and clicks between two sim steps. Several taps may arrive in one frame (two
 * fingers); each goes to the next step that runs.
 */
export class TapQueue {
	private pending: Tap[] = [];

	push(tap: Tap): void {
		this.pending.push(tap);
	}

	/** The taps for one step; the queue is empty afterwards. */
	take(): Tap[] {
		const taps = this.pending;
		this.pending = [];
		return taps;
	}

	clear(): void {
		this.pending = [];
	}
}
